module.exports = __webpack_public_path__ + "static/img/character-capricornus.4a88622f.png";